import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import useShopifyCollectionsSWR from '../../../../hooks/shopify/useShopifyCollectionsSWR';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { Box, Skeleton } from '@mui/material';
import { CollectionPagination } from '../../../collections/CollectionPagination';
import { CollectionWrapper } from '../../../collections/CollectionWrapper';

export const Collections: React.FC = () => {
    const { handle } = useParams();
    const [pagination, setPagination] = useState(0);
    const [resetpage, setResetpage] = useState(false);
    const item = useRef(null);
    const isNext = useRef(false);
    const sortKey = useRef('BEST_SELLING');
    const reverse = useRef(false);
    const { collection, isLoading, isError, forceRefresh } =
        useShopifyCollectionsSWR(handle, 50, {
            isNext: isNext.current,
            item: item.current,
            sortKey: sortKey.current,
            reverse: reverse.current,
        });
    const myRef = useRef(null);
    const executeScroll = () => myRef.current.scrollIntoView();

    const handlePagination = (pagination, currentItem, nextItem) => {
        item.current = currentItem;
        isNext.current = nextItem;
        executeScroll();
        setPagination(pagination);
    };

    const handleSort = (sort) => {
        item.current = null;
        isNext.current = false;
        sortKey.current = sort.shopifyKey;
        reverse.current = sort.reverse;
        if (pagination == 0) {
            setResetpage(!resetpage);
        } else {
            setPagination(0);
        }
    };

    // init to default after loading to avoid route change problem
    useEffect(() => {
        if (!isLoading) {
            item.current = null;
            isNext.current = false;
        }
    });

    return (
        <>
            <Box>
                {isLoading && (
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                )}
                <PageTitle>
                    {collection && collection.collectionTitle}
                </PageTitle>
            </Box>
            <div ref={myRef}></div>
            <CollectionWrapper
                products={collection && collection.products}
                handle={handle}
                isProductsLoading={isLoading}
                isProductsError={isError}
                handleSort={handleSort}
            />

            <CollectionPagination
                handlePagination={handlePagination}
                hasNextPage={collection && collection.hasNextPage}
                hasPreviousPage={collection && collection.hasPreviousPage}
                endCursor={collection && collection.endCursor}
                startCursor={collection && collection.startCursor}
                pagination={pagination}
            />
        </>
    );
};
